import { RowData } from '@tanstack/react-table';
import { TableContextType } from '../types';
import { createContext, useContext } from 'react';

export const TableContext = createContext<TableContextType<unknown> | null>(
  null,
);

export function useTableContext<TData extends RowData>() {
  const ctx = useContext(
    TableContext,
  ) as TableContextType<TData> as TableContextType<TData> | null;

  if (!ctx) {
    throw new Error(
      'useTableContext must be used within a TableContext.Provider',
    );
  }
  return ctx;
}
